export default __webpack_public_path__ + "static/media/545.21a630aa.jpg";